let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6wqeS")).then(() => parcelRequire('7p4p7'));